import styled from 'styled-components';

import Button from '@components/Button/next';
import Modal from '@components/Modal/next/Modal';

export const StyledButton = styled(Button)`
  width: 100%;
  height: 58px;
  margin-top: 41px;
  font-size: 18px;
  font-weight: bold;
  background-color: ${({ theme }) => theme.palette.tomato};
  color: ${({ theme }) => theme.palette.white};
  border: none;
`;
export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  display: flex;
  justify-content: center;
`;
export const FavoriteModal = styled(Modal)`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  z-index: 1005;
`;
export const Separator = styled.div<{ margin?: number }>`
  margin-top: ${({ margin }) => (margin ? `${margin}px` : '0')};
  margin-bottom: ${({ margin }) => (margin ? `${margin}px` : '0')};
  height: 1px;
  background-color: ${({ theme }) => theme.palette.lightBlueGrey};
`;

export const ColCustomIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  cursor: pointer;
  box-shadow: none;
`;

export const AddedFavorite = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.blue};
  font-weight: 600;
`;
export const CheckList = styled.div`
  font-size: 14px;
`;

export const CheckContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Container = styled.div``;
export const Added = styled.div`
  font-size: 14px;
`;

export const StyledButtonMobile = styled(Button)`
  width: 67px;
  min-height: 67px;
  font-size: 14px;
  font-weight: bold;
  background-color: ${({ theme }) => theme.palette.tomato};
  color: ${({ theme }) => theme.palette.white};
  border: none;
`;

export const IconContainer = styled.div``;

export const IconContainerMobile = styled.div`
  margin-bottom: 5px;
  margin-top: 15px;
`;
export const Span = styled.div`
  color: ${({ theme }) => theme.palette.coral};
  font-weight: 700;
`;
export const Wrapper = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const Input = styled.input`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.D200};
  border: 1px solid ${({ theme }) => theme.palette.iron};
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  border-radius: 4px;
  padding: 6px 10px 6px 10px;
  width: 100%;
  outline: none;
  :focus {
    border: 1px solid ${({ theme }) => theme.palette.iron};
  }
`;
export const InputMobile = styled.input`
  width: 80%;
  height: 67px;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.D200};
  border: 1px solid ${({ theme }) => theme.palette.iron};
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  border-radius: 4px;
  padding: 6px 10px 6px 10px;
  outline: none;
  :focus {
    border: 1px solid ${({ theme }) => theme.palette.iron};
  }
`;
export const CheckboxContainer = styled.div`
  font-size: 12px;
  display: flex;
  gap: 5px;
  flex-direction: column;
  input[type='radio']:not(old):checked {
    background-image: radial-gradient(
      circle at center,
      ${(p) => p.theme.palette.burntSienna},
      ${(p) => p.theme.palette.burntSienna} 37.5%,
      ${(p) => p.theme.palette.white} 40%,
      ${(p) => p.theme.palette.white} 100%
    );
  }
  max-height: 175px;
  overflow: auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px 20px;
  }
`;
export const CheckboxContainerMobile = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  column-gap: 5px;
  input[type='radio']:not(old):checked {
    background-image: radial-gradient(
      circle at center,
      ${(p) => p.theme.palette.burntSienna},
      ${(p) => p.theme.palette.burntSienna} 37.5%,
      ${(p) => p.theme.palette.white} 40%,
      ${(p) => p.theme.palette.white} 100%
    );
  }
  overflow: scroll;
  max-height: calc(100vh - 300px);
`;

export const MessageContainer = styled.div`
  color: ${(p) => p.theme.palette.darkGray};
  font-size: 18px;
  line-height: 1.56;
  text-align: center;
`;
export const CheckboxContainerItem = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 10px;
`;
export const HeaderBox = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  gap: 20px;
`;
export const ProfileRedirectContainer = styled.div``;

export const ProfileRedirectContainerMobile = styled.div`
  margin-bottom: 5px;
  margin-top: 15px;
`;

export const StatusMessage = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.D400};
  width: 100%;
  text-align: center;
`;

export const ProfileRedirectContainerButton = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.B400};
  width: 100%;
  cursor: pointer;
  text-align: center;
`;
export const StatusMessagePopUp = styled.div<{
  isHomePage?: boolean;
  isTour?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${({ isHomePage }) => (isHomePage ? '5px 5px' : '12px 24px')};
  gap: 10px;
  position: absolute;
  width: ${({ isHomePage }) => (isHomePage ? '190px' : '225px')};
  justify-content: center;
  padding-top: 10px;
  height: ${({ isHomePage }) => (isHomePage ? 'auto' : '48px')};
  box-shadow: 0px 0px 40px rgba(58, 58, 58, 0.2);
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  z-index: 100;
  top: ${({ isHomePage }) => (isHomePage ? '40px' : '330px')};
  left: ${({ isHomePage }) => (isHomePage ? 'calc(0% - 150px)' : '0')};
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 200px;
    top: ${({ isHomePage }) => (isHomePage ? '40px' : '70px')};
    left: ${({ isHomePage }) =>
      isHomePage ? 'calc(100% - 200px)' : 'calc(100% - 150px)'};
    padding: ${({ isHomePage }) => (isHomePage ? '12px 12px' : '0')};
  }
  @media (max-width: 880px) {
    left: ${({ isHomePage }) =>
      isHomePage ? 'calc(0% - 145px)' : 'calc(100% - 225px)'};
    padding: ${({ isHomePage }) => (isHomePage ? '0' : '12px 24px')};
    top: ${({ isTour, isHomePage }) =>
      isHomePage ? '40px' : isTour ? '36px' : '330px'};
  }
`;
export const StatusMessagePopUpText = styled.span`
  line-height: 24px;
  text-align: center;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 18px;
    line-height: 23px;
  }
`;
export const StatusMessagePopUpTickBox = styled.span`
  display: flex;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export const StatusMessagePopUpNonListing = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 24px;
  gap: 10px;
  position: absolute;
  width: 225px;
  justify-content: center;
  padding-top: 10px;
  height: 48px;
  box-shadow: 0px 0px 40px rgba(58, 58, 58, 0.2);
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  z-index: 2000;
  left: calc(100% - 225px);
  top: 50px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 200px;
    left: calc(70% - 203px / 2 + 0.5px);
    top: 75px;
    padding: 0;
  }
`;
export const FavoriteStyledButton = styled(Button)`
  width: 100%;
  height: 58px;
  margin-top: 41px;
  font-size: 18px;
  font-weight: bold;
  background-color: ${({ theme }) => theme.palette.tomato};
  color: ${({ theme }) => theme.palette.white};
  border: none;
`;
